import { get, post, put } from 'utils/methods';

export function getShippingTypesApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}shipping-types`, data, headers);
}

export function addShippingTypeApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/shipping-type`, data, headers);
}

export function editShippingTypeApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_ORDERS}commands/shipping-type`, data, headers);
}

export function updateTranslateShippingTypeApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/shipping-type/translate`, data, headers);
}
